async function getCartItems() {
  try {
    const response = await fetch("/cart.js");
    const cartData = await response.json();
    return cartData.items; // Return the array of cart items
  } catch (error) {
    console.error("Error fetching cart data:", error);
    throw error; // Rethrow the error for further handling
  }
}

function cleanProductTitles() {
  // Find all product title elements in the cart
  const cartItems = document.querySelector('.cart-items');
  const productTitles = cartItems.querySelectorAll('.item-title');
  
  productTitles.forEach(titleElement => {
    let titleElementSpan = titleElement.querySelector('span');
    const originalTitle = titleElementSpan.textContent;
    
    // Check if title contains a forward slash
    if (originalTitle.includes('/')) {
      // Split the title by slash and take the part after it
      const parts = originalTitle.split('/');
      // Get the text after the slash, trimming any leading spaces
      const cleanedTitle = parts[1].trim();
      // Update the title
      titleElementSpan.textContent = cleanedTitle;
    }
  });
}

function disableCheckout() {
  document.querySelectorAll(".cart__checkout-button").forEach((button) => {
    button.setAttribute('disabled', 'disabled');
    button.classList.add('disabled');
    const originalText = button.innerHTML;
    button.dataset.originalText = originalText;
    button.innerHTML = '<span class="btn-spinner"></span> Processing...';
  });
}

function enableCheckout() {
  document.querySelectorAll(".cart__checkout-button").forEach((button) => {
    button.removeAttribute('disabled');
    button.classList.remove('disabled');
    if (button.dataset.originalText) {
      button.innerHTML = button.dataset.originalText;
    } else {
      button.innerHTML = 'Checkout';
    }
  });
}

function formatDateToDMY(dateString) {
  const dateParts = dateString.split("-"); // Split the date string into [year, month, day]
  const year = dateParts[0];
  const month = dateParts[1];
  const day = dateParts[2];
  return `${day}.${month}.${year}`; // Return the formatted date string
}

function sortSizes(sizes) {
  const sizeOrder = ["XS", "S", "M", "L", "XL", "XXL"];
  return sizes.sort((a, b) => {
    const isNumericA = !isNaN(a);
    const isNumericB = !isNaN(b);

    if (isNumericA && isNumericB) {
      // Numeric comparison
      return parseInt(a, 10) - parseInt(b, 10);
    } else if (!isNumericA && !isNumericB) {
      // Standard size comparison
      return sizeOrder.indexOf(a) - sizeOrder.indexOf(b);
    } else if (isNumericA) {
      // Numbers come before standard sizes
      return -1;
    } else {
      return 1;
    }
  });
}

// async function updateCartLineAttributes(cartItems) {
//   console.log('updating cart line attributes');
//   for (let item of cartItems) {
//     // Fetch the latest shipping date for the product
//     const response = await fetchLatestShippingDate(item.product_id);
//     if (
//       response &&
//       response.data &&
//       response.data.product &&
//       response.data.product.metafield
//     ) {
//       const shippingDateValue = response.data.product.metafield.value;
//       if (shippingDateValue) {
//         // Format the shipping date to "DD.MM.YYYY"
//         const formattedDate = formatDateToDMY(shippingDateValue);
//         console.log(formattedDate);
//         // updates[item.key] = item.quantity; // Maintain current quantity
//         // updates[`properties[_shipped_by_${item.key}]`] = formattedDate;

//         //if current formatteddate same as new one, don't update, otherwise do
//         if (item.properties["_shipped_by"] == formattedDate) {
//           console.log("no need to update");
//         } else {
//           await updateCartItemAttribute(item.key, formattedDate);
//         }
//       }
//     }
//   }

//   // Proceed to checkout with updated cart items
//   window.location.href = "/checkout";
// }


async function updateCartLineAttributes(cartItems) {  
  let updatedAnyItems = false;
  
  cartItems.forEach((item, index) => {
    // console.log(`Item ${index}:`, {
    //   product_id: item.product_id,
    //   variant_id: item.variant_id,
    //   key: item.key,
    //   title: item.title,
    //   properties: item.properties,
    //   shipping_date: item.properties ? item.properties["_shipped_by"] : "no properties"
    // });
  });
    
  try {
    // Use Promise.all to wait for all updates to complete
    const updatePromises = cartItems.map(async (item, index) => {
      // Fetch the latest shipping date for the product and variant
      // console.log(`Processing item ${index} (${item.product_id}/${item.variant_id})`);
      const shippingDateResult = await fetchLatestShippingDate(item.product_id, item.variant_id);
      // console.log(`Got response for item ${index}:`, shippingDateResult);
      
      if (shippingDateResult.value) {
        // Format the shipping date to "DD.MM.YYYY"
        const formattedDate = formatDateToDMY(shippingDateResult.value);
        // console.log(`Formatted shipping date (from ${shippingDateResult.source}): ${formattedDate}`);

        // If current formatted date is different from the new one, update
        if (item.properties && item.properties["_shipped_by"] === formattedDate) {
          // console.log("No need to update - dates match");
          return false; // No update performed
        } else {
          // console.log(`Updating shipping date from ${item.properties?._shipped_by || "none"} to ${formattedDate}`);
          await updateCartItemAttribute(item.key, formattedDate);
          return true; // Update performed
        }
      } else {
        console.warn(`No shipping date found for product/variant ${item.product_id}/${item.variant_id}`);
        return false; // No update performed
      }
    });
    
    // Wait for all updates to complete and check if any were updated
    const updateResults = await Promise.all(updatePromises);
    updatedAnyItems = updateResults.some(result => result === true);
    
    // Now it's safe to redirect
    if (updatedAnyItems) {
      // console.log("Shipping dates were updated, proceeding to checkout");
    } else {
      // console.log("No shipping dates needed updating, proceeding to checkout");
    }
    
    window.location.href = "/checkout";
  } catch (error) {
    console.error("Error updating shipping dates:", error);
    enableCheckout(); // Make sure checkout is re-enabled if there's an error
    alert("There was an error updating shipping dates. Please try again or contact customer support.");
  }
}


async function fetchLatestShippingDate(productId, variantId) {
  // console.log(`Fetching shipping date for product ${productId}, variant ${variantId}`);
  
  const query = `
    query getMetafields($productId: ID!, $variantId: ID!) {
      product(id: $productId) {
        title
        id
        metafield(namespace: "custom", key: "shipping_date") {
          value
        }
      }
      node(id: $variantId) {
        ... on ProductVariant {
          id
          title
          metafield(namespace: "custom", key: "shipping_date") {
            value
          }
        }
      }
    }
  `;

  try {
    const response = await fetch(
      `https://www.suspiciousantwerp.com/api/2024-01/graphql.json`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "ceb147defbf38c2961f56ba858496258",
        },
        body: JSON.stringify({ 
          query: query, 
          variables: { 
            productId: `gid://shopify/Product/${productId}`,
            variantId: `gid://shopify/ProductVariant/${variantId}`
          }
        }),
      }
    );

    const data = await response.json();
    // console.log(`Metafield response:`, data);
    
    // Check variant metafield first
    if (data?.data?.node?.metafield?.value) {
      return {
        source: 'variant',
        value: data.data.node.metafield.value
      };
    }
    
    // Fall back to product metafield
    if (data?.data?.product?.metafield?.value) {
      return {
        source: 'product',
        value: data.data.product.metafield.value
      };
    }
    
    // If neither has a shipping date, return null
    return { source: 'none', value: null };
    
  } catch (error) {
    console.error("Error fetching metafields:", error);
    return { source: 'error', value: null };
  }
}


async function updateCartItemAttribute(lineKey, shippingDate) {
  try {
    const payload = {
      id: lineKey,
      properties: {
        _shipped_by: shippingDate, // Set the updated shipping date
      },
    };

    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const updatedCartData = await response.json();
  } catch (error) {
    console.error("Error updating cart item:", error);
    throw error; // Rethrow the error for further handling
  }
}

async function handleCheckoutClick(event) {
  event.preventDefault();
  disableCheckout();

  try {
    const cartItems = await getCartItems(); // Fetch current cart items
    // console.log("Cart Items:", cartItems);
    await updateCartLineAttributes(cartItems); // Update cart line attributes
  } catch (error) {
    console.error("Error updating cart:", error);
  } finally {
    enableCheckout();
  }
}

if (typeof CartForm !== "function") {
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.ajaxifyCartItems();
      cleanProductTitles();
      if (this.form) {
        this.form.addEventListener("submit", this.onSubmit.bind(this));
      }
    }

    async onSubmit(event) {
      event.preventDefault(); // Prevent the default form submission
      // Add your form submission logic here
      // console.log("Form submitted:", this.form);
      // You can call your updateCartQty or any other logic here
    }
  
    ajaxifyCartItems() {
      document.querySelectorAll(".cart__checkout-button").forEach((button) => {
        button.addEventListener("click", handleCheckoutClick);
      });
  
      this.querySelectorAll("[data-js-cart-item]").forEach((item) => {
        this.setupCartItemListeners(item);
      });
    }
  
    setupCartItemListeners(item) {
      const remove = item.querySelector(".remove");
      if (remove) {
        remove.dataset.href = remove.getAttribute("href");
        remove.setAttribute("href", "javascript:void(0);");
        remove.addEventListener("click", (e) => {
          e.preventDefault();
          this.updateCartQty(item, 0);
        });
      }
  
      const qty = item.querySelector(".qty");
      if (qty) {
        qty.addEventListener("change", (e) => {
          e.preventDefault();
          const newQty = parseInt(e.target.value, 10);
          if (!isNaN(newQty)) {
            this.updateCartQty(item, newQty);
          }
        });
      }
    }
  
    changeCartInput(item, change) {
      const qtyInput = item.querySelector(".qty");
      const newQty = parseInt(qtyInput.value) + change;
      qtyInput.value = newQty;
      this.updateCartQty(item, newQty);
    }

    updateCartQty(item, newQty) {
      // console.log('here');
      let alert = null;

      this.form.classList.add("processing");
      if (this.querySelector(".alert")) {
        this.querySelector(".alert").remove();
      }

      const body = JSON.stringify({
        line: parseInt(item.dataset.line),
        quantity: newQty,
      });

      fetch(KROWN.settings.routes.cart_change_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/javascript",
        },
        body,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status == 422) {
            // wrong stock logic alert
            alert = document.createElement("span");
            alert.classList.add("alert", "alert--error");
            if (typeof response.description === "string") {
              alert.innerHTML = response.description;
            } else {
              alert.innerHTML = response.message;
            }
          }
          return fetch("?section_id=helper-cart");
        })
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(
            text,
            "text/html"
          );
          const cartFormInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
          const cartSubtotalInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

          // const cartItems = document.getElementById("AjaxCartForm");
          // cartItems.innerHTML = cartFormInnerHTML;
          // cartItems.ajaxifyCartItems();

          const amountOfItems = sectionInnerHTML.querySelector('span[data-cart-count]')?.textContent;
          const cartItems = document.getElementById("AjaxCartForm");
          
          if(amountOfItems != 0) {
            const cartItemsHeader = sectionInnerHTML.querySelector('.site-cart-heading')?.innerHTML;
            const cartItemsHolder = sectionInnerHTML.querySelector('.cart-holder')?.innerHTML;
            const cartItemsHolderDataItems = sectionInnerHTML.querySelector('.cart-holder')?.getAttribute('data-items');
            
            //update header
            if (cartItems.querySelector('.site-cart-heading')) {
              cartItems.querySelector('.site-cart-heading').innerHTML = cartItemsHeader;
            }
            
            cartItems.querySelector('.cart-holder').innerHTML = cartItemsHolder;
            cartItems.querySelector('.cart-holder').setAttribute('data-items', cartItemsHolderDataItems);
            cartItems.ajaxifyCartItems();
          } else {
            cartItems.innerHTML = cartFormInnerHTML;
            cartItems.ajaxifyCartItems();
          }

          document
            .querySelectorAll("[data-header-cart-count]")
            .forEach((elm) => {
              elm.textContent = amountOfItems;
              // console.log('updating header cart count here to', elm, amountOfItems);
            });
          
          document
            .querySelectorAll("[data-header-cart-total")
            .forEach((elm) => {
              elm.textContent =
                cartItems.querySelector("[data-cart-total]").textContent;
            });

          if (alert !== null) {
            this.form.prepend(alert);
          }

          document.getElementById("AjaxCartSubtotal").innerHTML =
            cartSubtotalInnerHTML;

          document.dispatchEvent(new CustomEvent('cart:updatecache'));

          const event = new Event("cart-updated");
          this.dispatchEvent(event);
        })
        .catch((e) => {
          let alert = document.createElement("span");
          alert.classList.add("alert", "alert--error");
          console.log('there is an error', e);
          alert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(alert);
        })
        .finally(() => {
          this.form.classList.remove("processing");
          document
            .getElementById("cart-continueshopping")
            .addEventListener("click", () => {
              if (document.querySelector("sidebar-drawer.active"))
                document.querySelector("sidebar-drawer.active").hide();
            });
          document
            .querySelectorAll(".cart__checkout-button")
            .forEach((button) => {
              button.addEventListener("click", handleCheckoutClick);
            });
          cleanProductTitles();
          reinitializeTrustpilot();
        });
    }
  }

  if (typeof customElements.get("cart-form") == "undefined") {
    customElements.define("cart-form", CartForm);
  }
}

if (typeof CartProductQuantity !== "function") {
  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.minusButton = this.querySelector(".qty-minus");
      this.plusButton = this.querySelector(".qty-plus");
      this.input = this.querySelector(".qty");
      
      this.minusButton.addEventListener("click", this.onMinusClick.bind(this));
      this.plusButton.addEventListener("click", this.onPlusClick.bind(this));
      
      // Store the original quantity
      this.originalQuantity = parseInt(this.input.value, 10);
    }

    onMinusClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const newValue = this.originalQuantity - 1;
      this.updateQuantity(newValue);
    }

    onPlusClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const newValue = this.originalQuantity + 1;
      this.updateQuantity(newValue);
    }

    updateQuantity(newValue) {
      if (newValue !== this.originalQuantity) {
        this.input.value = newValue;
        this.originalQuantity = newValue;
        
        // Use requestAnimationFrame to ensure the DOM has updated
        requestAnimationFrame(() => {
          const cartForm = document.getElementById("AjaxCartForm");
          if (cartForm && typeof cartForm.updateCartQty === 'function') {
            cartForm.updateCartQty(this.closest("[data-js-cart-item]"), newValue);
          } else {
            console.error("AjaxCartForm or updateCartQty not found");
          }
        });
      }
    }
  }

  if (typeof customElements.get("cart-product-quantity") == "undefined") {
    customElements.define("cart-product-quantity", CartProductQuantity);
  }
}

// Add a MutationObserver to watch for checkout buttons being added to the DOM
const checkoutButtonObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Check if the added node is a checkout button
          if (node.classList && node.classList.contains('cart__checkout-button')) {
            attachCheckoutHandler(node);
          }
          
          // Check if the added node contains checkout buttons
          const buttons = node.querySelectorAll('.cart__checkout-button');
          buttons.forEach(attachCheckoutHandler);
        }
      });
    }
  });
});

// Function to attach the checkout handler to a button
function attachCheckoutHandler(button) {
  // Remove any existing handlers first to prevent duplicates
  button.removeEventListener('click', handleCheckoutClick);
  // Add the handler
  button.addEventListener('click', handleCheckoutClick);
}

// Start observing the document body for added nodes
checkoutButtonObserver.observe(document.body, { 
  childList: true, 
  subtree: true 
});

// Initially attach handlers to any existing checkout buttons
document.querySelectorAll('.cart__checkout-button').forEach(attachCheckoutHandler);

//attach listener for cart refresh
document.addEventListener("cart:refresh", () => {
  window.refreshCart();
});

// method for apps to tap into and refresh the cart

if (!window.refreshCart) {
  window.refreshCart = (showCart = true) => {
    // console.log('triggered refreshcart');
    //update the cart data now for product pages
    lastCartUpdateTimestamp = 0; // Reset timestamp to force a new fetch on next check
    cachedCartData = null;
    
    const isB2BCustomer =
      document
        .querySelector('meta[name="isB2BCustomer"]')
        .getAttribute("content") === "true";

    fetch("?section_id=helper-cart")
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser().parseFromString(
          text,
          "text/html"
        );
        const cartFormInnerHTML =
          sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
        const cartSubtotalInnerHTML =
          sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

        // const cartItems = document.getElementById("AjaxCartForm");
        // cartItems.innerHTML = cartFormInnerHTML;
        // cartItems.ajaxifyCartItems();

        const cartItems = document.getElementById("AjaxCartForm");
        const cartItemsHeader = sectionInnerHTML.querySelector('.site-cart-heading').innerHTML;
        const cartItemsHolder = sectionInnerHTML.querySelector('.cart-holder').innerHTML;
        const cartItemsHolderDataItems = sectionInnerHTML.querySelector('.cart-holder')?.getAttribute('data-items');
        
        //update header
        cartItems.querySelector('.site-cart-heading').innerHTML = cartItemsHeader;
        cartItems.querySelector('.cart-holder').innerHTML = cartItemsHolder;
        cartItems.querySelector('.cart-holder').setAttribute('data-items', cartItemsHolderDataItems);
        cartItems.ajaxifyCartItems();


        document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
          elm.textContent = sectionInnerHTML.querySelector('span[data-cart-count]')?.textContent;
            // cartItems.querySelector("[data-cart-count]").textContent;
        });

        document.querySelectorAll("[data-header-cart-total").forEach((elm) => {
          elm.textContent =
            cartItems.querySelector("[data-cart-total]").textContent;
        });

        document
          .querySelectorAll(".cart__checkout-button")
          .forEach((button) => {
            button.addEventListener("click", handleCheckoutClick);
          });

        document.getElementById("AjaxCartSubtotal").innerHTML =
          cartSubtotalInnerHTML;

        cleanProductTitles();
        reinitializeTrustpilot();
        document
          .getElementById("cart-continueshopping")
          .addEventListener("click", () => {
            if (document.querySelector("sidebar-drawer.active"))
              document.querySelector("sidebar-drawer.active").hide();
          });


        if (document.querySelector("[data-js-site-cart-sidebar]") && showCart) {
          document.querySelector("[data-js-site-cart-sidebar]").show();
        } else {
        }

        if (document.querySelector("cart-recommendations")) {
          document.querySelector("cart-recommendations").innerHTML = "";
          document
            .querySelector("cart-recommendations")
            .generateRecommendations();
        }

        // Reattach remove button logic for B2B customers after refreshing cart
        if (isB2BCustomer) {
          const removeButtons = document.querySelectorAll(".remove-product");
          removeButtons.forEach((button) => {
            button.addEventListener("click", function () {
              const productId = this.getAttribute("data-product-id");

              // Fetch the current cart
              fetch("/cart.js")
                .then((response) => response.json())
                .then((cart) => {
                  const updates = {};

                  // Build the updates object to remove all variants of the product
                  cart.items.forEach((item) => {
                    if (item.product_id == productId) {
                      updates[item.variant_id] = 0; // Set quantity to 0 to remove
                    }
                  });

                  // Perform the bulk update to remove all matching items
                  fetch("/cart/update.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ updates }),
                  })
                    .then((response) => response.json())
                    .then(() => {
                      // Refresh the cart after updating
                      window.refreshCart(false);
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                    });
                });
            });
          });
        }
      });
  };
}
